export default function GridCursor(props: { fill?: string }) {
	return (
		<svg width="39" height="37" viewBox="0 0 39 37" className="h-[37px] w-[39px]" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_2040_35901)">
				<path
					d="M7.7446 30.1738C7.84921 30.6919 8.28135 31.0801 8.80774 31.1288C9.33413 31.1774 9.8301 30.875 10.0279 30.3848L14.2306 19.9697L24.1212 21.537C24.6501 21.6208 25.1703 21.3432 25.395 20.8571C25.6197 20.3711 25.4943 19.7949 25.0879 19.4463L4.13425 1.47183C3.74639 1.13911 3.19008 1.08932 2.7493 1.34787C2.30852 1.60642 2.08049 2.11628 2.18162 2.61719L7.7446 30.1738Z"
					fill={props.fill ?? '#7ADFED'}
					stroke="#212020"
					strokeWidth="2.39394"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2040_35901">
					<rect width="39" height="37" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
